import { RouterProvider } from 'react-router-dom';
import { router } from 'src/routes';
import UIProviders from 'src/components/ui/UIProviders';
import { ApolloProvider } from '@apollo/client/react';
import client from 'src/api/apollo/client';

export default function App() {
	return (
		<ApolloProvider client={client}>
			<UIProviders>
				<RouterProvider router={router} />
			</UIProviders>
		</ApolloProvider>
	);
}
